import { ToastLevel } from '@philips-emr/tws-constants';
import { FileService } from '@philips-emr/tws-core/lib/services';

import { ToastService } from './toast-service';

interface Download {
  endpoint: string,
  name?: string;
  parameters?: {},
}

export default class DownloadService {

  static of(arg: Download): void {
    const { endpoint, name, parameters } = arg;

    ToastService.open({ message: 'hi.download-started', level: ToastLevel.INFORMATION });

    FileService.download(endpoint, name, parameters)
      .catch(() => ToastService.open({ message: 'hi.file-not-found', level: ToastLevel.CAUTION }));
  }
}
